import { FYDEOS_NOTES_PRODUCT } from '@affine/component/product-brand';

export const DEFAULT_SELF_HOSTED_SERVER_NAME = FYDEOS_NOTES_PRODUCT;
const LEGACY_SERVER_NAMES = new Map([
  ['affine self-hosted', FYDEOS_NOTES_PRODUCT],
  ['affine cloud', `${FYDEOS_NOTES_PRODUCT} Cloud`],
  ['affine beta cloud', `${FYDEOS_NOTES_PRODUCT} Cloud`],
  ['affine canary cloud', `${FYDEOS_NOTES_PRODUCT} Cloud`],
]);

export function getFydeOSServerDisplayName(serverName?: string | null) {
  if (!serverName) {
    return FYDEOS_NOTES_PRODUCT;
  }

  return LEGACY_SERVER_NAMES.get(serverName.trim().toLowerCase()) ?? serverName;
}

export function getSelfHostedServerName(serverName?: string | null) {
  if (!serverName) {
    return DEFAULT_SELF_HOSTED_SERVER_NAME;
  }

  const normalizedServerName = getFydeOSServerDisplayName(serverName);
  if (normalizedServerName === DEFAULT_SELF_HOSTED_SERVER_NAME) {
    return DEFAULT_SELF_HOSTED_SERVER_NAME;
  }

  return normalizedServerName === `${FYDEOS_NOTES_PRODUCT} Cloud`
    ? normalizedServerName
    : `${DEFAULT_SELF_HOSTED_SERVER_NAME} (${normalizedServerName})`;
}
